import { SplitText } from '@cyriacbr/react-split-text';
import { shape, string } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { renderLineWrapper, renderWordWrapper } from './renderWrapper';
import { Container } from './TypingTextAnimation.layoutProps';

const TypingTextAnimation = ({
  boldStartText,
  outerContainerRef,
  text,
  textProps,
}) => {
  const [activeAnimation, setActiveAnimation] = useState(-1);
  const containerRef = useRef();
  const [childsCount, setChildsCount] = useState(1);
  const [lineWidths, setLineWidths] = useState();

  const updateLineWidth = () => {
    const arr = Array?.from(containerRef?.current?.children);
    const widths = arr?.map((wrapper) => {
      const containerWidth =
        outerContainerRef?.current?.getBoundingClientRect().width;
      const lineWrapperWidth = wrapper.getBoundingClientRect().width;

      return lineWrapperWidth < 5 ? containerWidth : lineWrapperWidth;
    });
    setLineWidths(widths);
  };
  useEffect(() => {
    setTimeout(() => {
      setChildsCount(containerRef?.current?.childElementCount);
      updateLineWidth();
    }, 50);
  }, [containerRef?.current?.childElementCount, outerContainerRef?.current]);

  useEffect(() => {
    let interval;
    if (
      activeAnimation !== -1 &&
      activeAnimation <= childsCount &&
      lineWidths
    ) {
      interval = setInterval(
        () => {
          if (activeAnimation < childsCount) {
            setActiveAnimation((prev) => prev + 1);
          }
        },
        (lineWidths[activeAnimation] / 50) * 500
      );
    }
    return () => clearInterval(interval);
  }, [childsCount, activeAnimation, lineWidths]);

  useEffect(() => {
    setTimeout(() => {
      setActiveAnimation(0);
    }, 500);
  }, []);
  return (
    <Container>
      <SplitText
        ref={containerRef}
        LineWrapper={renderLineWrapper(
          textProps,
          activeAnimation,
          lineWidths ? lineWidths[activeAnimation] : null
        )}
        WordWrapper={renderWordWrapper([0, 1])}
      >
        {`${boldStartText} ${text}`}
      </SplitText>
    </Container>
  );
};

TypingTextAnimation.propTypes = {
  boldStartText: string,
  outerContainerRef: shape.isRequired,
  text: string.isRequired,
  textProps: shape,
};

TypingTextAnimation.defaultProps = {
  boldStartText: null,
  textProps: null,
};

export default TypingTextAnimation;
